var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{ref:"diagram",staticClass:"diagram",staticStyle:{"height":"100%"}}),_c('component-context-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }